<template>
  <div class="radio-container" v-bind:class="{'radio-disabled':disabled, 'radio-active':selected}">
    <div
      class="radio-group"
      @click="toggle()"
    >
      <input
        type="radio"
        :id="id || uniqueId"
        :name="name"
        :value="radioValue"
        :disabled="disabled"
        :required="required"
        :color="color"
        :selected="radioButtonState"
        @change="toggle()"
        v-gaEvent="{ category: gacategory, action: gaaction, label: galabel }"
      >

      <label class="checkbox_label" :for="id || uniqueId">
        <slot/>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadioButton',

  props: {
    id: {
      type: String,
      default: undefined,
    },
    selectedValue: null,
    radioValue: null,
    name: String,
    required: Boolean,
    disabled: Boolean,
    color: String,
    gacategory: null,
    gaaction: null,
    galabel: null,
  },
  data() {
    return {
      uniqueId: '',
      selected: false,
    };
  },
  computed: {
    radioButtonState() {
      if (this.selectedValue == this.radioValue) {
        this.selected = true;
      }

      return this.selected;
    },
  },
  methods: {
    toggle() {
      if (this.disabled) return;

      this.$emit('input', this.radioValue);
    },
  },
  watch: {
    selectedValue(newVal) {
      if (newVal != this.radioValue) {
        this.selected = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.radio-container {
  margin: unset;

  &.radio-active {
    .radio-group {
      // @apply ut-bg-G400 ut-text-n0;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
    }
  }

  .radio-group {
    @apply ut-px-4 ut-py-2 ut-text-center ut-cursor-pointer;
    border-radius: 18px;
    font-size: 16px;
    letter-spacing: 0.3px;
    label {
      @apply ut-cursor-pointer;
      font-size: 16px;
      letter-spacing: 0.3px;
    }

    //Hide input
    input {
      border: 0;
      clip: rect(0 0 0 0);
      height: 1px;
      margin: -1px;
      overflow: hidden;
      padding: 0;
      display: none;
      // position: absolute;
      width: 1px;
    }
  }
}
</style>
